/**
 * Created by Ning Jiang on 2024-01-10.
 */

import {WinPresentationController} from "../WinPresentationController";
import {DeadwoodRip} from "../../DeadwoodRip";
import {DeadwoodRipSymbolState} from "../../symbol/DeadwoodRipSymbolConfig";

export class DisableLastReelController extends WinPresentationController {

    constructor() {
        super("DisableLastReelController", false);
    }

    protected hasWin():boolean {
        return !DeadwoodRip.model.parsedGameData.lastReelEnabled;
    }

    protected async createWinAnimation():Promise<void> {
        DeadwoodRip.ways.updateSymbolWays(4, 0, 0, false);
        DeadwoodRip.ways.updateSymbolWays(4, 1, 1, false);
        DeadwoodRip.ways.updateAllWays(true);

        const promises:Promise<any>[] = [];
        promises.push(Promise.resolve(DeadwoodRip.reels[4].getSymbol(0).getStateAnimation(
            DeadwoodRipSymbolState.NO_WIN,
            {duration : 0.2, alpha : 1},
            {duration : 0.2, alpha : 0}
        )));
        promises.push(Promise.resolve(DeadwoodRip.reels[4].getSymbol(1).getStateAnimation(
            DeadwoodRipSymbolState.NO_WIN,
            {duration : 0.2, alpha : 1},
            {duration : 0.2, alpha : 0}
        )));

        await Promise.all(promises);
    }
}